import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';

import { MerchandisingHeroBanner as MerchandisingHeroBannerAEM } from './MerchandisingHeroBanner';

export const MerchandisingHeroBannerConfig = {
  emptyLabel: 'Merchandising Hero Banner',
  isEmpty: () => true,
  resourceType: `mi-aem-common-spa/components/content/merchandisingherobanner`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MerchandisingHeroBanner = (props: any) => {
  const isTargetEnabled = props.model.styleclass?.includes('enable-target') && !props.isAuthorMode;
  const updatedProps = {
    ...props,
    model: {
      ...props.model,
      isHomepage: props?.isHomepage || false,
    },
  };
  return (
    <div
      data-testid="homepage-herobanner"
      className={clsx('herobanner-fullbleed', {
        [`target-background herobanner-ratio-${props.model.heroSize}`]: isTargetEnabled,
      })}
    >
      <EditableComponent
        config={MerchandisingHeroBannerConfig}
        {...updatedProps}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        children={<MerchandisingHeroBannerAEM {...({} as any)} />}
      />
    </div>
  );
};
